module.exports = __webpack_public_path__ + "img/thumb_padrao_510x170.d6521d42.svg";